import { type ReactNode, useEffect } from 'react';
import { resolveTheme, useThemeStore } from './store';

function apply(resolved: 'light' | 'dark') {
  document.documentElement.dataset.theme = resolved;
}

/** Keeps <html data-theme> in sync with the preference, and with the OS when in "system". */
export function ThemeProvider({ children }: { children: ReactNode }) {
  const preference = useThemeStore((s) => s.preference);

  useEffect(() => {
    apply(resolveTheme(preference));
    if (preference !== 'system') return;

    const mq = window.matchMedia('(prefers-color-scheme: dark)');
    const onChange = () => apply(mq.matches ? 'dark' : 'light');
    mq.addEventListener('change', onChange);
    return () => mq.removeEventListener('change', onChange);
  }, [preference]);

  return <>{children}</>;
}
